import React, { useCallback } from 'react';
import { View, Text } from 'react-native';
import { shape } from 'prop-types';
import { FlatGrid } from 'react-native-super-grid';
import { ModalHeader, Hr } from 'LocalGluons';
import BigButton from 'LocalGluons/components/BigButton';
import { t } from 'Locale';
import { noop } from 'Utils';

import defaultStyles from './CopyFavorites.jss';

const CopyFavorites = ({ navigation, route }) => {
    const activeDevice = route.params?.activeDevice || {};

    const DEVICE_TYPES = {
        STB: 'STB',
        SMART_TV: 'SMART_TV',
        WEB_BROWSER: 'WEB_BROWSER',
        MOBILE_TABLET: 'MOBILE_TABLET'
    };
    const deviceOnPressCallback = route.params?.deviceOnPressCallback || noop;

    const onCloseCallback = useCallback(() => {
        navigation.pop();
    }, []);

    const devices = route.params?.devices || [];
    devices.filter((device) => device.isDeviceIptv === activeDevice.isDeviceIptv);

    const text = t('SETTINGS.FAVOURITE_CHANNELS_COPY_TXT').replace('XXX', activeDevice.title);

    const getIconPerPlatform = (item) => {
        switch (item.category) {
            case DEVICE_TYPES.STB:
                return 'device_stb';
            case DEVICE_TYPES.WEB_BROWSER:
                return 'laptop';
            case DEVICE_TYPES.MOBILE_TABLET:
                if (item.title.includes('iPhone')) return 'device_smartphone';
                if (item.title.includes('iPad')) return 'device_tablet';
                return 'mobile_tablet_devices';
            default:
                return 'devices';
        }
    };

    return (
        <View style={defaultStyles.modalContainer}>
            <ModalHeader
                onPress={onCloseCallback}
                style={{ iconContainer: defaultStyles.closeIcon }}
            />
            <View style={defaultStyles.container}>
                <Text style={defaultStyles.title}>
                    {t('SETTINGS.FAVOURITE_CHANNELS_COPY_TO_DEVICE')}
                </Text>
                <Hr />
                <Text style={[defaultStyles.title, defaultStyles.subTitle]}>{text}</Text>
                <FlatGrid
                    style={defaultStyles.gridView}
                    data={devices || []}
                    spacing={30}
                    renderItem={({ item }) => (
                        <BigButton
                            style={{
                                button: defaultStyles.button,
                                heading: defaultStyles.buttonHeadline
                            }}
                            iconName={getIconPerPlatform(item)}
                            key={item.id}
                            heading={item.title}
                            onPress={() => {
                                deviceOnPressCallback(item);
                                onCloseCallback();
                            }}
                        />
                    )}
                />
            </View>
        </View>
    );
};

CopyFavorites.propTypes = {
    navigation: shape({}).isRequired
};

export { CopyFavorites };
